// Mukti Hospital ERP - Reference Data Cache Helpers (Phase 1)
// NEW FILE: src/services/pathologyCache.js
//
// Two simple functions used by the Pathology components:
//
//   saveToCache(key, data)  -> save fresh data after a successful API call
//   readFromCache(key)      -> read cached data when the API is unreachable
//
// Both functions NEVER throw. If IndexedDB fails for any reason,
// saveToCache silently does nothing and readFromCache returns null,
// so the existing online flow is never affected.

import pathologyDb from './pathologyDb';

/**
 * Save data into the offline reference cache.
 * Fire-and-forget safe: never throws.
 * @param {string} key  e.g. "addbill_tests"
 * @param {any} data    usually the mapped options array used by the UI
 */
export const saveToCache = async (key, data) => {
  try {
    await pathologyDb.refCache.put({
      key,
      data,
      savedAt: new Date().toISOString(),
    });
  } catch (err) {
    // Non-critical: cache write failed, online flow continues normally
    console.warn(`[OfflineCache] Failed to save "${key}":`, err);
  }
};

/**
 * Read data from the offline reference cache.
 * @param {string} key
 * @returns {Promise<any|null>} cached data, or null if not found / error
 */
export const readFromCache = async (key) => {
  try {
    const entry = await pathologyDb.refCache.get(key);
    return entry ? entry.data : null;
  } catch (err) {
    console.warn(`[OfflineCache] Failed to read "${key}":`, err);
    return null;
  }
};